import React from 'react';
import { systemFlow } from '../data/copy';
export function Footer() {
  return <footer className="w-full border-t border-slate-800 bg-slate-900 pb-24 pt-10 [contain-intrinsic-size:auto_900px] [content-visibility:auto] sm:pb-10 [.chalk_&]:border-slate-200 [.chalk_&]:bg-white" data-id="element-105" data-mp="3gf94guwt048f">
      <div className="mx-auto max-w-5xl px-6 text-center" data-id="element-106" data-mp="36p6df098t0cq">
        <p className="text-xl font-extrabold uppercase tracking-[0.12em] text-slate-50 [.chalk_&]:text-slate-900" data-id="element-107" data-mp="36ppkflxcu4bz">
          Youth Basketball <span className="text-orange-400 [.chalk_&]:text-orange-600" data-id="element-108" data-mp="38qu4u3bljp2">360</span>™
        </p>
        <p className="mt-2 text-xs font-bold uppercase tracking-[0.24em] text-slate-400 [.chalk_&]:text-slate-600" data-id="element-109" data-mp="36d08okdmdj3">
          {systemFlow}
        </p>
        <div className="mx-auto mt-6 h-px w-16 bg-orange-400/50 [.chalk_&]:bg-orange-600/50" aria-hidden="true" data-id="element-110" data-mp="3qc41f9dfhwkl" />
        <p className="mt-6 text-sm leading-relaxed text-slate-400 [.chalk_&]:text-slate-600" data-id="element-111" data-mp="29xm0ypkw16jm">
          © 2026 YOUTH BASKETBALL 360™ — All rights reserved.
        </p>
        <p className="mt-1 text-sm text-slate-400 [.chalk_&]:text-slate-600" data-id="element-112" data-mp="3l8qwo57filrz">
          Digital coaching system for youth basketball coaches, PE teachers and
          parent-coaches.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-xs leading-relaxed text-slate-400 [.chalk_&]:text-slate-600" data-id="element-113" data-mp="3v7zwvfsw0wms">
          Results depend on how the system is applied in real coaching
          environments.
        </p>
      </div>
    </footer>;
}